"use client";

import React from "react";

import { ZoomControls } from "@/components/maps/zoom-controls";
import { useMapControls } from "@/providers/maps/hooks/use-map-controls";

interface ZoomControlsWrapperProps {
  className?: string;
}

export const ZoomControlsWrapper: React.FC<ZoomControlsWrapperProps> = ({
  className,
}) => {
  const { zoomPercentage, zoomIn, zoomOut } = useMapControls();

  return (
    <ZoomControls
      className={className}
      zoomPercentage={zoomPercentage}
      onZoomIn={zoomIn}
      onZoomOut={zoomOut}
    />
  );
};

